import { EndpointBuilder } from "@reduxjs/toolkit/query";
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from "@reduxjs/toolkit/query";
import { BaseQueryFn } from "@reduxjs/toolkit/query";
import {
  AdministrativeHierarchyDataResponse,
  AdministrativeHierarchyDataResponseModified
} from "../types";
export const MDMSFiltersAPIEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    "MDMSFiltersAPI"
  >
) => ({
  getZones: builder.query<AdministrativeHierarchyDataResponseModified, "">({
    query: () => ({
      url: "/administrative_hierarchy/zones"
    }),
    transformResponse: (
      response: AdministrativeHierarchyDataResponse
    ): AdministrativeHierarchyDataResponseModified => {
      const modifiedData = response.response.map((ele) => {
        return {
          label: ele.name,
          value: ele.id
        };
      });
      return {
        response: modifiedData
      };
    }
  }),
  getCircles: builder.query<
    AdministrativeHierarchyDataResponseModified,
    string
  >({
    query: (params) => ({
      url: `/administrative_hierarchy/circles${params}`
    }),
    transformResponse: (
      response: AdministrativeHierarchyDataResponse
    ): AdministrativeHierarchyDataResponseModified => {
      const modifiedData = response.response.map((ele) => {
        return {
          label: ele.name,
          value: ele.id
        };
      });
      return {
        response: modifiedData
      };
    }
  }),
  getDivisions: builder.query<
    AdministrativeHierarchyDataResponseModified,
    string
  >({
    query: (params) => ({
      url: `/administrative_hierarchy/divisions${params}`
    }),
    transformResponse: (
      response: AdministrativeHierarchyDataResponse
    ): AdministrativeHierarchyDataResponseModified => {
      const modifiedData = response.response.map((ele) => {
        return {
          label: ele.name,
          value: ele.id
        };
      });
      return {
        response: modifiedData
      };
    }
  }),
  getSubDivisions: builder.query<
    AdministrativeHierarchyDataResponseModified,
    string
  >({
    query: (params) => ({
      url: `/administrative_hierarchy/sub-divisions${params}`
    }),
    transformResponse: (
      response: AdministrativeHierarchyDataResponse
    ): AdministrativeHierarchyDataResponseModified => {
      const modifiedData = response.response.map((ele) => {
        return {
          label: ele.name,
          value: ele.id
        };
      });
      return {
        response: modifiedData
      };
    }
  })
});
